module.exports = __webpack_public_path__ + "img/settings_outlined_24.d5485a6b.svg";